var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplianceTime2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "#1F8342",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1246 13.7829L14.2669 9.62633L13.3701 8.7153L10.1246 11.9609L8.54448 10.3808L7.64769 11.2918L10.1246 13.7829ZM10.9883 17C10.1692 17 9.39266 16.8453 8.65883 16.5359C7.925 16.2265 7.28643 15.8001 6.74315 15.2569C6.19986 14.7136 5.77351 14.075 5.46411 13.3413C5.1547 12.6075 5 11.8301 5 11.0091C5 10.1796 5.15498 9.40009 5.46494 8.67065C5.77491 7.9412 6.20215 7.3033 6.74668 6.75694C7.29119 6.21057 7.92896 5.78115 8.66 5.4687C9.39103 5.15623 10.1655 5 10.9834 5C11.8143 5 12.5964 5.15586 13.3299 5.46759C14.0633 5.77932 14.7019 6.20781 15.2455 6.75304C15.7891 7.29827 16.2174 7.93658 16.5304 8.66796C16.8435 9.39934 17 10.1816 17 11.0148C17 11.8379 16.8438 12.6139 16.5313 13.3429C16.2188 14.0718 15.7894 14.7085 15.2431 15.2532C14.6967 15.7978 14.0588 16.2251 13.3292 16.5351C12.5997 16.845 11.8194 17 10.9883 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceTime2);
export default __webpack_public_path__ + "static/media/ComplianceTime2.c9d35a24d745178de6f6c18e5e65c432.svg";
export { ForwardRef as ReactComponent };